function cleanBaseUrl(value: string): string {
  return value.replace(/\/+$/u, '')
}

const variables = import.meta.env

export const platformEnv = {
  ssoApiUrl: cleanBaseUrl(variables.VITE_SSO_API_BASE_URL || 'https://api-sso.hocnhe.com'),
  ssoFrontendUrl: cleanBaseUrl(variables.VITE_SSO_FRONTEND_URL || 'https://sso.hocnhe.com'),
  courseApiUrl: cleanBaseUrl(variables.VITE_HOCNHE_COURSE_API_BASE_URL || 'https://hocnhe-course-api.hocnhe.com'),
  gatewayApiUrl: cleanBaseUrl(variables.VITE_GATEWAY_API_BASE_URL || 'https://ai.hocnhe.com'),
} as const
